import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'valueInArray',
})
export class ValueInArrayPipe implements PipeTransform {
    transform<T>(value: T, list: any[], trigger?: any): unknown {
        return list.includes(value);
    }
}
